export default __webpack_public_path__ + "static/media/Classwin-Document-blue.51215aae.svg";